/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { PAGE_NUMBER, PAGE_SIZE } from "../../container/Users/constants";
import { FUNCTIONAL, DATA, ENTITIES, DIMENSION, DIMENSIONV2, MEASURE } from '../../shared/PolicyDialog/constants';
import {
  IPage,
  IAssignedUsersDefaultParamsSearch
} from "../../models/AssignedUsers/AssignedUsers";

export const POLICIES = 'Policies';
export const ASSIGNED_USERS = 'Assigned Users';
export const LOCATIONS = 'Assigned Sub-Realms';

export const SEARCH = 'Search';

export const SEARCH_PERMISSIONS = 'Search Permission';

export const SEARCH_POLICIES_MAX_LENGTH = 20;

export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};
export const SAVE = "Save";
export const DELETE_TITLE = "Are you sure You want to delete the ";
export const DIALOUGE_CONTENT = "Delete Policy?";
export const DIALOUGE_OK = "Delete Policy";
export const DIALOUGE_CANCEL = "Cancel";
export const EMPTY_SCREEN_TEXT = "Add Policy Rule";
export const EMPTY_SCREEN_TITLE = "Add some policy rules";
export const ADD_RULE = "Add Policy";
export const PERMISSION_SAVED_SUCCESSFULY = "Policy added successfully";
export const PERMISSION_ALREADY_EXIST = 'Policy already exist: ';
export const PERMISSION_REMOVED_ERROR = 'Error in removing policy: ';
export const ERROR_FETCHING_DATA = 'There is some problem in fetching data, please contact your system administrator';

export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const NOT_APPLICABLE = 'N/A';
export const COPY_RULE_MSG = 'Policy Rule JSON Copied!';
export const LABEL = {
  USER_NAME: 'User Name',
  NAME: "Display Name",
  EMAIL: "Email",
  NO_VALUE: "--",
};
export const assignedUsersDefaultSearchParams: IAssignedUsersDefaultParamsSearch = {
  'page-number': PAGE_NUMBER,
  'page-size': PAGE_SIZE,
};
export const pageData: IPage = {
  pageNumber: PAGE_NUMBER,
  pageSize: PAGE_SIZE,
};
export const FILTER_BY_POLICY_TYPE = 'Filter by policy type';
export const EDIT = 'edit';
export const DELETE = 'delete';

export const POLICY_TYPE_KEYS = {
  DATA: 'hierarchy',
  ENTITY: 'entity',
  MEASURE_GROUP: 'logicalmodel-measuregroup-access-control',
  MEASURE: 'logicalmodel-measure-access-control',
  DIMENSION: 'logicalmodel-dimension-access-control'
} as const;
export const POLICY_TYPE_LABELS = [
  { key: FUNCTIONAL, displayName: 'Functional', filterLabel: 'Functional' },
  { key: DATA, displayName: 'Data', filterLabel: 'Data' },
  { key: ENTITIES, displayName: 'Entity', filterLabel: 'Entity' },
  { key: DIMENSION, displayName: 'Logicalmodel Dimension', filterLabel: 'Dimension' },
  { key: DIMENSIONV2, displayName: 'Logicalmodel Dimension V2', filterLabel: 'Dimension' },
  { key: MEASURE, displayName: 'Logicalmodel Measure', filterLabel: 'Measure' }
];

export const POLICY_TYPE_LABELS_WITHOUT_DIMENSION_V2 = [
  { key: FUNCTIONAL, displayName: 'Functional', filterLabel: 'Functional' },
  { key: DATA, displayName: 'Data', filterLabel: 'Data' },
  { key: ENTITIES, displayName: 'Entity', filterLabel: 'Entity' },
  { key: DIMENSION, displayName: 'Logicalmodel Dimension', filterLabel: 'Dimension' },
  { key: MEASURE, displayName: 'Logicalmodel Measure', filterLabel: 'Measure' }
];

export const ASSIGN_TO_LOCATION = 'Assign To Sub-Realm';
export const EMPTY_LOCATIONS_DISPLAY_MESSAGE = 'No Sub-Realms To Display';
export const ROLE_LOCATION_ASSIGNMENT_INFO = 'This role is at the realm-level. It can be used in all sub-realms. To limit it to specific sub-realms, assign to sub-realms.';
export const LOCATION_ROLE_MANAGEMENT_HINT_DESCRIPTION = 'Optional. Use sub-realms to manage roles for physical areas (warehouse, retail, department, etc.)';
export const DISASSOCIATE = 'Disassociate';
export const DISASSOCIATE_TITLE = "Are you sure You want to disassociate the ";
export const DISASSOCIATED_LOCATION = 'Disassociate Sub-Realm';
export const DELETE_CONTENT = 'Are you sure You want to delete the ';
